import { Navigate, useLocation } from "react-router-dom";
import { loginUrl, unAuthPath } from "@/utils/base";
import { getServiceVal } from "@/utils/cookies";
import { checkIsDocs } from "@/utils";
import { rootRoutes } from "@/routes";
import { RouteItemType } from "@/types/routes";
import { checkDocumentUrl, goLogin } from "@/utils/common";
import { docsPrefix } from "@/pages/document";

const UserStatusComponent = (params: { children: any }) => {
  const location = useLocation();
  const { pathname } = location;
  const children = params.children;
  const routers:any[]=[];
  /**
   * 扁平化路由 提取path
   * @param routerArr 路由数组
   * @param fatherPath 上级name
   */
  const getRouters=(routerArr:RouteItemType[],fatherPath:any=null)=>{
    
    routerArr.forEach((item)=>{
        let  path=item.path;
        if(path?.[0]!='/'){
            path=fatherPath==null?'/'+path:fatherPath+'/'+path;
        }
        if(item.children && item.children.length>0){
            getRouters(item.children,path=='/'?'':path);
        }else{
            routers.push(path);
        }
    })
  }
  getRouters(rootRoutes);
  let isMyRouter=false;
  try {
    routers.forEach((item)=>{
        let isRouter=false;
        const pathNames=pathname.split('/');
        const routers=item.split('/');
        if(checkDocumentUrl(pathname) ) {
            //过滤文档
            isMyRouter=true;
            return
        }
        if(pathNames?.length==routers?.length){
            //相同个数 路径匹配 过滤参数
            const argArr:any[]=routers.filter((item:any)=>!item.includes(':'));
            isRouter=argArr.every((item,index)=>pathNames[index]==item);
            if(isRouter){
                isMyRouter=isRouter;
            }
        }
      })
  } catch (error) {
    console.error(error);
  }
  // console.log('is my router',isMyRouter);
  if(!isMyRouter){
    return <Navigate to={''}/>
  }

  const checkLogin = getServiceVal('Authorization') || unAuthPath.some((path) => pathname.includes(path)) || checkIsDocs(pathname) || pathname === '/'

  if (checkLogin) {
    return <>{children}</>;
  } else {
    // 跳转至登录页面
    goLogin();
    return <>{children}</>;
  }
};

export { UserStatusComponent };
